export const getDefaultFractionDigits = (locale, currency) => {
  return new Intl.NumberFormat(locale, {
    style: "currency",
    currency
  }).resolvedOptions().maximumFractionDigits ?? 2;
};
